import { useContext } from 'react';
import classNames from 'classnames';

import { MembershipPaymentSectionContext } from '..';
import styles from './ChoosePaymentMethod.module.scss';

const ChoosePaymentMethod = () => {
  const { currentPaymentBy, setPaymentBy } = useContext(
    MembershipPaymentSectionContext,
  );
  return (
    <div className={styles.paymentMethodSection}>
      <div
        className={classNames(styles.paymentByTab, {
          [styles.active]: currentPaymentBy === 'credit',
        })}
        onClick={() => setPaymentBy('credit')}
      >
        クレジットカード
      </div>
      <div
        className={classNames(styles.paymentByTab, {
          [styles.active]: currentPaymentBy === 'coin',
        })}
        onClick={() => setPaymentBy('coin')}
      >
        PostPrime Coin
      </div>
    </div>
  );
};

export default ChoosePaymentMethod;
